import {
  CASELOAD_SOURCE_CUSTOM_SCRIPT,
  CASELOAD_SOURCE_CSV,
} from 'modules/RosterAndTagManagement/constants';

const options = [
  {
    id: CASELOAD_SOURCE_CSV,
    name: 'CSV',
  },
  {
    id: CASELOAD_SOURCE_CUSTOM_SCRIPT,
    name: 'Custom',
  },
];

const getStudentTagSourceFilter = () => ({
  key: 'studentTagSource',
  source: 'studentTagSource',
  filterName: 'Source',
  searchable: false,
  defaultSelection: options,
  options,
  selector: 'id',
  label: 'name',
});

export default getStudentTagSourceFilter;
